import { addMonths, differenceInCalendarMonths, format, parseISO } from 'date-fns'

import type { TPeriodicidadePagamentoEnum } from '@/types/simulacao'
import type { TGrupoParcela } from '@/utils/calculadora-valores-totais/processador-valores-decimal'

export class CalculadoraPeriodicidade {
  static readonly valorDaPeriodicidade: Record<TPeriodicidadePagamentoEnum, number> = {
    Anual: 12,
    Semestral: 6,
    Trimestral: 3,
    Bimestral: 2,
    SemPeriodoFixo: 0,
  }

  private static readonly periodicidadePorMeses = new Map<number, TPeriodicidadePagamentoEnum>([
    [12, 'Anual'],
    [6, 'Semestral'],
    [3, 'Trimestral'],
    [2, 'Bimestral'],
  ])

  static readonly recalcularDatas = (
    dataInicio: string,
    periodicidade: TPeriodicidadePagamentoEnum,
    parcelas: NonNullable<TGrupoParcela[]>,
  ): NonNullable<TGrupoParcela[]> => {
    const intervalo = this.valorDaPeriodicidade[periodicidade]
    if (intervalo === 0) return parcelas
    return parcelas.map((parcela, index) => ({
      ...parcela,
      data: format(addMonths(parseISO(dataInicio), intervalo * index), 'yyyy-MM-dd'),
    }))
  }

  static calcular(datas: string[]): TPeriodicidadePagamentoEnum {
    if (!datas || datas.length < 2) return 'SemPeriodoFixo'
    const [data1, data2] = datas
    if (!data1 || !data2) return 'SemPeriodoFixo'
    const primeira = parseISO(data1)
    const segunda = parseISO(data2)

    const diferencaMeses = Math.abs(differenceInCalendarMonths(primeira, segunda))

    return this.periodicidadePorMeses.get(diferencaMeses) ?? 'SemPeriodoFixo'
  }
}
